import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'

import { SearchResults } from '../SearchResults/SearchResults'

import styles from './DevApp.module.css'

export const DevApp = () => (
  <BrowserRouter basename='/'>
    <div className={styles.wrapper}>
      <h1>DEV</h1>
      <Switch>
        <Route component={SearchResults} exact path='/' />
        <Route render={() => <h2>Route not found</h2>} />
      </Switch>
    </div>
  </BrowserRouter>
)
